import { Box } from "@mui/material";
import { useSelector } from "react-redux";
import ViewPolicyDocument from "../../../pages/admin/project/project-details/components/ViewPolicyDocument";

type PolicyDrawerComponentProps = {
    handleClose: (open: boolean) => () => void;
}

const PolicyDrawerComponent: React.FC<PolicyDrawerComponentProps> = ({handleClose}) => {
    const drawer = useSelector((state: any) => state.drawer);

    return (
        <Box>    
            {drawer.name === 'View Document' && <ViewPolicyDocument />}       
        </Box>
    )
}
export default PolicyDrawerComponent